module.exports = __webpack_public_path__ + "components/login/static/background-3d8f3744da691267d495a7e8d8e92c97.jpg";